module.exports = __webpack_public_path__ + "static/img/HT.99dcfcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/HT.png
// module id = cURB
// module chunks = 34